import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'loadingSnippet',
  props: {
    text: {
      type: String,
      default: 'loading'
    }
  },
  data: function () {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  },
}

